import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";
import { NgxEchartsModule } from "ngx-echarts";

import { MatInputModule } from "@angular/material/input";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatListModule } from "@angular/material/list";
import { MatSidenavModule } from "@angular/material/sidenav";

import { ContractsRoutingModule } from "./contracts-routing.module";
import { CustomTableModule } from "src/app/shared/modules/custom-table/custom-table.module";
import { TopCardMaterialModule } from "src/app/shared/modules/top-card-material/top-card-material.module";
import { DateTimeModule } from "src/app/shared/modules/date-time/date-time.module";
import { DialogModule } from "src/app/shared/modules/dialogs/dialog.module";
import { SelectionListModule } from "src/app/shared/modules/selection-list/selection-list.module";
import { LimitCardsListModule } from "src/app/shared/modules/limit-cards-list/limit-cards-list.module";

import { ContractListComponent } from "./contract-list/contract-list.component";
import { ContractDetailComponent } from "./contract-detail/contract-detail.component";
import { ContractCardsListComponent } from './contract-cards-list/contract-cards-list.component';
import { ContractMovementsListComponent } from './contract-movements-list/contract-movements-list.component';

@NgModule({
  imports: [
    CommonModule,
    ContractsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CustomTableModule,
    TopCardMaterialModule,
    MatProgressBarModule,
    MatTabsModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatChipsModule,
    MatListModule,
    MatSidenavModule,
    FlexLayoutModule,
    DateTimeModule,
    DialogModule,
    SelectionListModule,
    LimitCardsListModule,
    NgxEchartsModule,
  ],
  declarations: [
    ContractListComponent,
    ContractDetailComponent,
    ContractCardsListComponent,
    ContractMovementsListComponent,
  ],
})
export class ContractsModule {}
